import $ from 'jquery';
import 'slick-carousel';
import Player from '@vimeo/player';

const cardSliderOptions = {
  autoplay: true,
  autoplaySpeed: 5000,
  adaptiveHeight: true,
  slidesToShow: 1,
  fade: true,
  speed: 300,
  asNavFor: '[js-hero-carousel-bg-slider]',
  prevArrow: '[js-hero-carousel-prev]',
  nextArrow: '[js-hero-carousel-next]'
};

const bgSliderOptions = {
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  arrows: false,
  speed: 300,
  cssEase: 'ease-in-out'
};

function videoPlay(video) {
  video.play();
}

function videoPause(video) {
  video.pause();
}

const initCardSlider = () => {
  const slider = document.querySelector('[js-hero-carousel-card-slider]');
  if (slider) {
    $(slider).slick(cardSliderOptions);
  }
};

const initBgSlider = () => {
  const slider = document.querySelector('[js-hero-carousel-bg-slider]');
  const gradient = document.querySelector('[js-hero-carousel="gradient"]');

  if (slider) {
    $(slider).slick(bgSliderOptions);

    $(slider).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const $currentSlide = $(slider).find(slick.$slides.get(currentSlide));
      const $nextSlide = $(slider).find(slick.$slides.get(nextSlide));


      $currentSlide.find('iframe').each((i, el) => {
        const player = new Player(el);
        videoPause(player);
      });

      $nextSlide.find('iframe').each((i, el) => {
        const player = new Player(el);
        videoPlay(player);
      });

      if (!$nextSlide.find('iframe').length) {
        gradient.classList.remove('hide');
      } else {
        gradient.classList.add('hide');
      }
    });
  }
};

const heroCarousel = async () => {
  const slider = document.querySelector('[js-hero-carousel-bg-slider]');
  let firstSlide = $(slider).find('.hero-carousel__bg-slide').first();
  let hasVideo = firstSlide.find('iframe').length > 0;

  if(hasVideo) {
    bgSliderOptions.autoplay = false;
    cardSliderOptions.autoplay = false;
  }

  initCardSlider();
  initBgSlider();
};

export default heroCarousel;
